export default "__VITE_ASSET__as8WhRDG__"